import types from '../../constants';

export function selectExercise(id) {
  return { type: types.EXERCISES_SELECT, payload: id };
}

export function deleteExercise(id) {
  return async (dispatch) => {
    dispatch({ type: types.EXERCISES_LOADING_START });
    global.socket.emit('exercise_delete', { id });
  };
}


export function changeFilter(key, value) {
  return {
    type: types.EXERCISES_CHANGE_FILTER,
    payload: {
      key,
      value,
    },
  };
}

export function resetFilter() {
  return { type: types.EXERCISES_RESET_FILTER };
}

export function fetchExercises(filters) {
  global.socket.emit('exercise_list', filters);
  return { type: types.SOCKET_ACTION };
}
